exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resource .panel {\n  padding: 2rem 1rem; }\n\n.resource .icon {\n  font-size: 350%;\n  color: #d1d6db;\n  text-align: center; }\n\n.resource .title {\n  font-weight: bold; }\n\n.resource .description {\n  color: #898a8e;\n  margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/resources/show-resource/show-resource.component.scss
// module id = 414
// module chunks = 0